import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { DEAL_QUEUE_STATUS_FILTERS } from '@aica/api-types/schemas';

/** Queue filter: a status bucket or «closed in the CRM». */
export type DealsQueueStatus = (typeof DEAL_QUEUE_STATUS_FILTERS)[number];

export interface DealsSearch {
  status?: DealsQueueStatus;
}

const VALID_STATUSES: ReadonlySet<string> = new Set(DEAL_QUEUE_STATUS_FILTERS);

// RBAC is enforced in-tree (RouteRoleGate → screen `deals`, lib/route-permissions.ts);
// the `enableDealStateSummary` flag hides the menu entry (sidebar-config.ts) and
// the server's 403 closes the data — the screens read it (`DealFeatureClosed`). An unknown
// `?status=` is dropped silently: the queue opens unfiltered.
export const Route = createFileRoute('/deals')({
  component: lazyRouteComponent(() => import('./-deals.lazy'), 'default'),
  validateSearch: (search: Record<string, unknown>): DealsSearch => ({
    ...(typeof search.status === 'string' && VALID_STATUSES.has(search.status)
      ? { status: search.status as DealsQueueStatus }
      : {}),
  }),
});
